// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.causeCategoryTableWrapper__qlZ3H {
  width: 100%;
  max-width: 100%;
  max-height: calc(100vh - 305px);
  overflow: auto;
  box-shadow: 0px 3px 8px -1px rgba(50, 50, 71, 0.0509803922), 0px 0px 1px 0px rgba(12, 26, 75, 0.2392156863);
}
.causeCategoryTableWrapper__qlZ3H::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.causeCategoryTableWrapper__qlZ3H::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.causeCategoryTableWrapper__qlZ3H::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.causeCategoryTableWrapper__qlZ3H::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 875px) {
  .causeCategoryTableWrapper__qlZ3H {
    max-height: calc(100vh - 265px);
  }
}

.causeCategoryTable__g__ZT {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  position: relative;
}
.causeCategoryTable__g__ZT th {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--tables-title-text);
  padding: 10px 25px;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  text-align: left;
  text-wrap: nowrap;
  position: sticky;
  top: 0;
}
@media (max-width: 1300px) {
  .causeCategoryTable__g__ZT th {
    padding: 10px 10px;
  }
}
@media (max-width: 1015px) {
  .causeCategoryTable__g__ZT th {
    padding: 10px 5px;
  }
}
.causeCategoryTable__g__ZT td {
  padding: 19px 25px;
  color: var(--tables-primary-row-text-main);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  white-space: normal;
  font-size: 14px;
}
@media (max-width: 1300px) {
  .causeCategoryTable__g__ZT td {
    padding: 10px 10px;
  }
}
@media (max-width: 1015px) {
  .causeCategoryTable__g__ZT td {
    font-size: 12px;
    padding: 10px 5px;
  }
}

.faultNameColumn__zqweW {
  display: flex;
  align-items: center;
}

.faultNameColumnTitle__w0hiJ {
  text-wrap: auto;
}

.bodyRow__HNdBa:hover td {
  background: var(--tables-primary-row-surface-hover);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}

.ellipsisTextOneLine___bQ1_ {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
}

.ellipsisTextTwoLine__bqmMY {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

.sortIcon__aD7RZ {
  margin-left: 5px;
  cursor: pointer;
  outline: none;
  min-width: 6px;
}
.sortIcon__aD7RZ path {
  fill: var(--tables-title-icon);
}

.activeSort__Spp1S path {
  fill: var(--tables-primary-row-icon);
}

.tableFooter__DSQ5x {
  margin-top: 25px;
  height: 24px;
  text-align: right;
}
@media (max-width: 875px) {
  .tableFooter__DSQ5x {
    margin-top: 15px;
  }
}

.skeletonText__nvELF {
  height: 12px;
}

.viewDetailsLink__pEsEK {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: end;
  padding: 19px 25px;
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--table-box-shadow);
  text-transform: uppercase;
}
.viewDetailsLink__pEsEK a {
  color: var(--buttons-surface);
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  text-decoration: none;
  display: flex;
  align-items: center;
}
.viewDetailsLink__pEsEK svg {
  margin-left: 10px;
}
.viewDetailsLink__pEsEK svg path {
  stroke: var(--buttons-surface);
}
@media (max-width: 1300px) {
  .viewDetailsLink__pEsEK {
    padding: 10px 10px;
  }
}
@media (max-width: 1015px) {
  .viewDetailsLink__pEsEK {
    font-size: 12px;
    padding: 10px 5px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/AssetHealthDetails/components/CauseCategoryTable/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,2GACE;AA1EJ;AAoBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,+BAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,8BAAA;EACA,kBAAA;AApBJ;AAuBE;EACE,gBAAA;EACA,kBAAA;AArBJ;AA6DE;EAVF;IAWI,+BAAA;EA1DF;AACF;;AA6DA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AA1DF;AA4DE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,mDAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;AA1DJ;AA4DI;EAdF;IAeI,kBAAA;EAzDJ;AACF;AA2DI;EAlBF;IAmBI,iBAAA;EAxDJ;AACF;AA2DE;EACE,kBAAA;EACA,0CAAA;EACA,yDAAA;EACA,qDAAA;EACA,mBAAA;EACA,eAAA;AAzDJ;AA2DI;EARF;IASI,kBAAA;EAxDJ;AACF;AA0DI;EAZF;IAaI,eAAA;IACA,iBAAA;EAvDJ;AACF;;AA2DA;EACE,aAAA;EACA,mBAAA;AAxDF;;AA2DA;EACE,eAAA;AAxDF;;AA4DE;EACE,mDAAA;EACA,yDAAA;AAzDJ;;AA6DA;EAxGE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAqGA,qBAAA;EACA,aAAA;AArDF;;AAwDA;EA9GE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EA2GA,qBAAA;EACA,aAAA;AAhDF;;AAmDA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AAhDF;AAkDE;EACE,8BAAA;AAhDJ;;AAqDE;EACE,oCAAA;AAlDJ;;AAsDA;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;AAnDF;AAqDE;EALF;IAMI,gBAAA;EAlDF;AACF;;AAqDA;EACE,YAAA;AAlDF;;AAqDA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,qDAAA;EACA,mCAAA;EAEA,yBAAA;AAnDF;AAqDE;EACE,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AAnDJ;AAsDE;EACE,iBAAA;AApDJ;AAsDI;EACE,8BAAA;AApDN;AAwDE;EA9BF;IA+BI,kBAAA;EArDF;AACF;AAuDE;EAlCF;IAmCI,eAAA;IACA,iBAAA;EApDF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.causeCategoryTableWrapper {\n  width: 100%;\n  max-width: 100%;\n  max-height: calc(100vh - 305px);\n  overflow: auto;\n  box-shadow:\n    0px 3px 8px -1px #3232470d,\n    0px 0px 1px 0px #0c1a4b3d;\n  @include scrollBar;\n\n  @media (max-width: 875px) {\n    max-height: calc(100vh - 265px);\n  }\n}\n\n.causeCategoryTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  position: relative;\n\n  th {\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 12px;\n    text-transform: uppercase;\n    color: var(--tables-title-text);\n    padding: 10px 25px;\n    border-bottom: 1px solid var(--tables-title-stroke);\n    background: var(--tables-title-surface);\n    text-align: left;\n    text-wrap: nowrap;\n    position: sticky;\n    top: 0;\n\n    @media (max-width: 1300px) {\n      padding: 10px 10px;\n    }\n\n    @media (max-width: 1015px) {\n      padding: 10px 5px;\n    }\n  }\n\n  td {\n    padding: 19px 25px;\n    color: var(--tables-primary-row-text-main);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-primary-row-surface-default);\n    white-space: normal;\n    font-size: 14px;\n\n    @media (max-width: 1300px) {\n      padding: 10px 10px;\n    }\n\n    @media (max-width: 1015px) {\n      font-size: 12px;\n      padding: 10px 5px;\n    }\n  }\n}\n\n.faultNameColumn {\n  display: flex;\n  align-items: center;\n}\n\n.faultNameColumnTitle {\n  text-wrap: auto;\n}\n\n.bodyRow {\n  &:hover td {\n    background: var(--tables-primary-row-surface-hover);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n  }\n}\n\n.ellipsisTextOneLine {\n  @include ellipsis-text;\n  -webkit-line-clamp: 1;\n  line-clamp: 1;\n}\n\n.ellipsisTextTwoLine {\n  @include ellipsis-text;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n}\n\n.sortIcon {\n  margin-left: 5px;\n  cursor: pointer;\n  outline: none;\n  min-width: 6px;\n\n  path {\n    fill: var(--tables-title-icon);\n  }\n}\n\n.activeSort {\n  path {\n    fill: var(--tables-primary-row-icon);\n  }\n}\n\n.tableFooter {\n  margin-top: 25px;\n  height: 24px;\n  text-align: right;\n\n  @media (max-width: 875px) {\n    margin-top: 15px;\n  }\n}\n\n.skeletonText {\n  height: 12px;\n}\n\n.viewDetailsLink {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  text-align: end;\n  padding: 19px 25px;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--table-box-shadow);\n\n  text-transform: uppercase;\n\n  a {\n    color: var(--buttons-surface);\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 14px;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n  }\n\n  svg {\n    margin-left: 10px;\n\n    path {\n      stroke: var(--buttons-surface);\n    }\n  }\n\n  @media (max-width: 1300px) {\n    padding: 10px 10px;\n  }\n\n  @media (max-width: 1015px) {\n    font-size: 12px;\n    padding: 10px 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"causeCategoryTableWrapper": `causeCategoryTableWrapper__qlZ3H`,
	"causeCategoryTable": `causeCategoryTable__g__ZT`,
	"faultNameColumn": `faultNameColumn__zqweW`,
	"faultNameColumnTitle": `faultNameColumnTitle__w0hiJ`,
	"bodyRow": `bodyRow__HNdBa`,
	"ellipsisTextOneLine": `ellipsisTextOneLine___bQ1_`,
	"ellipsisTextTwoLine": `ellipsisTextTwoLine__bqmMY`,
	"sortIcon": `sortIcon__aD7RZ`,
	"activeSort": `activeSort__Spp1S`,
	"tableFooter": `tableFooter__DSQ5x`,
	"skeletonText": `skeletonText__nvELF`,
	"viewDetailsLink": `viewDetailsLink__pEsEK`
};
module.exports = ___CSS_LOADER_EXPORT___;
